// @ts-nocheck
import { get } from 'lodash'
import { FormFieldLayout, FormInput } from '../../generic'

export default function FormattedTextField({
  errors,
  formKey,
  onChange,
  options,
  placeholder,
  readOnly,
  style,
  values,
  format = true,
  ...props
}) {
  const value = get(values, formKey)
  const error = get(errors, formKey)

  if (readOnly) return <ReadOnly value={value} />

  return (
    <FormFieldLayout hasErrors={!!error} {...props}>
      <FormInput
        error={error}
        format={format}
        onChange={(e) =>
          onChange({
            key: formKey,
            value: formatValueForSubmission(e.target.value, options)
          })
        }
        options={options}
        placeholder={placeholder}
        style={style}
        value={value}
        data-testid={props['data-testid']}
      />
    </FormFieldLayout>
  )
}

const ReadOnly = ({ value }) => <div style={styles.readOnly}>{value}</div>

const styles = {
  readOnly: {
    padding: '12px 12px 12px 0px'
  }
}

const formatValueForSubmission = (value, options) => {
  if (options.delimiter && !options.date) {
    return value.split(options.delimiter).join('')
  }
  return value
}
